<template>
  <div class="lesson-header">
    <div class="backarrowDiv" v-on:click="prevChapter">
      <inline-svg
        class="arrow-svg-lesson"
        :src="arrowIconPath.arrowIconPrevious"
      ></inline-svg>
    </div>
    <div class="lesson-titles">
      <h2 v-if="currentData">
        {{ currentData.courseName }}
      </h2>
      <h6 v-if="currentData">
        {{ lessonName ? lessonName : "" }}
      </h6>
      <h6 v-if="outerData">
        {{ outerData ? outerData : "" }}
      </h6>
    </div>

    <inline-svg
      class="cup-svg"
      :class="{ noShow: outerData }"
      :src="require('../../assets/svg/lesson.svg').default"
    ></inline-svg>
  </div>
</template>

<script>
import "./lesson-header.scss";
import { getArrowIconPath } from "../../utils/svgConfig";
import { languageDirectionMapping } from "../../main";

export default {
  name: "lesson-header",
  props: ["currentData", "outerData", "externalType"],
  data() {
    return {
      lessonName: "",
      arrowIconPath: {
        arrowIconNext: "",
        arrowIconPrevious: ""
      }
    };
  },
  async created() {
    this.arrowIconPath = getArrowIconPath(localStorage.getItem("srcDirection"));
  },
  watch: {
    currentData() {
      this.lessonName = this.currentData ? this.currentData.name : "";
    }
  },
  mounted() {
    this.lessonName = this.currentData ? this.currentData.name : "";
  },
  methods: {
    prevChapter: function(event) {
      console.log("VLIVK");
      if (this.externalType === "grammar" || this.externalType === "sentence")
        this.$emit("closeIntro", "ok");

      if (!this.externalType)
        this.$router.push({
          path: `/chapter/`
        });
    }
  },
  components: {}
};
</script>

<style scoped>
.backarrowDiv {
  display: flex;
  width: 50px;
  height: 50px;
}
.arrow-svg-lesson {
  margin: auto;
}
.noShow {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// lesson-header.vue?8dcff0c6